//import liraries
import React, { useEffect, useState, useRef, useFocusEffect, BackHandler} from "react";
import {View, Text, TextInput, TouchableOpacity, Dimensions, Image, Linking, Platform} from "react-native";
import CustomButton from "../../common/CustomButton";
import CustomTextInput from "../../common/CustomTextInput";
import CustomInput from "../../common/CustomInput";
import { decryptCaptcha, Encryption as encrypt, decrypt } from "../../utilities/Encryption";
import { getCpatcha, sendOtp, validateOtp, getEncKey, login } from "../../api/apiManager";
import { useLogin } from '../../context/loginProvider';
import AsyncStorageFunc from '../../utilities/asyncStorage'
import * as RootNavigation from "../../utilities/RootNavigation"
import CImage from "../../common/CImage";
import CCheckbox from "../../common/CCheckBox";
import Header from "../../common/Header";
import LoginTabIcons from "./LoginTabIcons";
import LoginRightWidget from "./LoginRightWidget"; 
import LoginMoibleContent from "./LoginMobileContent";
import LoginFooter from "./LoginFooter";
import { COLORS, FONTS } from "../../constant";
import CountdownTimer from "../../common/CTimer.web";
import CText from "../../common/CText";
import useStyles from "./LoginComponent_Styles";
import VirtualKeyboard from "../../utilities/VirtualKeyboard.web";
import CCheckboxWithLabel from "../../common/CCheckBoxWithLabel";
const isSmallDevice = Dimensions.get("window").width < 767;

// create a component
const LoginComponent = (props) => {
  const screenType = 'Login';
  const otpPattern = /^\d{6}$/
  const mobilePattern = /^\d{10}$/
  const mobileRegex = /^([6-9]{1})([0-9]{9})/g;
  const styles = useStyles();
  const counterRef = useRef(null);
  const [userId, setUserId] = useState("");
  const [passwordString, setPasswordString] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isCorporate, setIsCorporate] = useState(false);
  const [isShowOtpScreen, setIsShowOtpScreen] = useState(true);
  const [requestOtp, setRequestOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [second, setSecond] = useState(60);
  const [timer, setTimerOn] = useState(false);
  const [isLoading, setIsLoading] = useState("");
  const [otpResponse, setOtpResponse] = useState("");
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [enteredCaptcha, setEnteredCaptcha] = useState("");
  const [isRememberChecked, setIsRememberChecked] = useState(true);
  const [errormsg,setErrorMessage] = useState("")
  const inputRef = useRef(null);
  const [useVirtualKeyboard, setUseVirtualKeyboard] = useState(false);
  const [activeField, setActiveField] = useState('password'); //default password active field

  const maskInput = (value) => {
    // Replace each character with a masking character
    return '*'.repeat(value.length);
  };
  const handleInputChange = (text,field,value) => {
    setPasswordString(text);
    // Mask the input and set it back to the TextInput
    if (inputRef.current) { inputRef.current.setNativeProps({ text: maskInput(text) });}
     // set the value with virtual keyboard
    // if (field === 'userId') {
    //   setUserId(value);
    // } else 
    if (field === 'password') {
      setPasswordString(value);
      if (inputRef.current) { inputRef.current.setNativeProps({ text: maskInput(value) });}
    } 
    // else if (field === 'otp') {
    //   setOtp(value);
    // }
  };

 const disableBack = () =>{
  history.pushState(null, null, location.href);
    window.onpopstate = function () { history.go(1);};
 }

  useEffect(() => {
    disableBack()
    generateCaptcha();
    if(global?.loginTYpe == "otpLogin" && isShowOtpScreen){
      setUserId(global?.mobileNo)
    }else{setUserId("")}
  }, [])

  const generateCaptcha = () => {
    setCaptcha("")
    getCpatcha()
      .then((res) => {
        decryptCaptcha(res?.data).then((res) => {
          setCaptcha(res?.captchaCode)
          setCaptchaId(res?.captchaId)
        });
      }).catch((err) => {
        const routeObj = { title: "Captcha", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
        RootNavigation.navigate("ResponseScreen", { data: routeObj })
      });
  };

const toggleKeyboard = (field) => {
  if (useVirtualKeyboard) 
  {
    setUseVirtualKeyboard(true);
    setActiveField(field);
  }
};

// Modify the onFocus of each input to trigger virtual keyboard toggle
const onFocusHandler = (field) => {
  toggleKeyboard(field);
};
const setInputValue = (value) => {
  if (activeField === 'userId') {
    setUserId(value);
  } else if (activeField === 'password') {
    setPasswordString(value);
    if (inputRef.current) { inputRef.current.setNativeProps({ text: maskInput(value) });}
  } else if (activeField === 'otp') {
    setOtp(value);
  }
};
  const onSubmit = () => {
    global.loginTYpe = "passwordLogin";
    getEncKey().then(async res => {
      if (res.statusCode == 200) {
        const keepMeSignIn = isRememberChecked ? "Y" : "N"
        const encKey = res?.data || ""
        let userNameToEncrypt = `${userId}~${captchaId}:${enteredCaptcha}`
        const encryptedId = await encrypt(userNameToEncrypt, encKey)
        const encryptedPassword = await encrypt(passwordString, encKey)
        const reqObj = { username: encryptedId, password: encryptedPassword, keepMeSignIn: keepMeSignIn };
        login(reqObj).then(async res => {
          if (res?.status == 200) {
            if (res?.data?.access_token) {
              const loginData = await decrypt(res?.data?.access_token)
              AsyncStorageFunc.storeData('TOKEN', res?.data?.access_token)
              global.token = res?.data?.access_token;
              global.userId = loginData.userId;
              global.userCd = loginData.userCd;
              global.fullName = loginData.fullName ? loginData.fullName : "";
              global.userType = loginData.userType;
              setIsLoggedIn(true)
              let route = global?.prevRoute || "/Home"
              route = route.slice(1) 
              RootNavigation.navigate(route, { params: { showConfig: "showConfig"}, })
              global.activeScreen = route
              global.showConfig = true
            }
             }else if(es?.status  == -1087 ){
                  const routeObj = {
                    username :userId,
                    password:passwordString,
                    loginType :"passwordLogin",
                    title:"Login",
                    type : "Error",
                    msg: errData?.message,
                    btnText :"Back To Login",
                    navigation :  "Login",
                }
                RootNavigation.navigate("ResponseScreen",{ data : routeObj  })
                }
            }).catch(err=>{
                const errData = err?.response?.data
                let isForceLogin = false;
                let route = global?.prevRoute || "/Home"
                 route = route.slice(1) 
                if( errData?.message == "You are already logged in to another device. Do you want to continue here")isForceLogin = true
                const routeObj = {
                    username :userId,
                    password:passwordString,
                    loginType :"passwordLogin",
                    title:"Login",
                    type : "Error",
                    msg: errData?.message,
                    btnText :isForceLogin ? "Continue":"Back To Login",
                    navigation : isForceLogin ? route : "Login",
                    isForceLogin : isForceLogin,
                    keepMeSignIn : isRememberChecked ? "Y" : "N"
                } 
                if( errData?.message == "Multiple accounts are linked to this number. Please try using user id and password for login as login through mobile number is not allowed in this case"){
                  RootNavigation.navigate("LoginByVrnScreen",{ data : routeObj  })
               }else{
                RootNavigation.navigate("ResponseScreen",{ routeObj  })
               }
            })
        }
    }).catch(err => {
      setIsLoading(false)
      const routeObj = { title: "Login ", type: "Error", msg: err?.response?.data?.message, btnText: "Ok", navigation: "Login", }
      RootNavigation.navigate("ResponseScreen", { data: routeObj })
    })
  };

  const onSendOtp = (reqObj) => {
    sendOtp(reqObj).then(res => {
      setIsLoading(false)
      if (res?.data?.statusCode == 1003) {
        setOtpResponse(res?.data)
        setIsShowOtpScreen(true);
      }else if(res?.data?.statusCode  < 0 ){
        let routeObj = {
          title:"Login With Otp",
          type : "Error",
          msg: res?.data?.message,
          btnText :"Ok",
          navigation : "Login",
          keepMeSignIn : isRememberChecked ? "Y" : "N"
      }
      if( res?.data?.message == "Multiple accounts are linked to this number. Please try using user id and password for login as login through mobile number is not allowed in this case"){
        RootNavigation.navigate("LoginByVrnScreen",{ data : routeObj, userId:userId  })
        setRequestOtp(false)
     }else{
      RootNavigation.navigate("ResponseScreen",{ data : routeObj  })
      setRequestOtp(false)
     }}
    }).catch(err => {
      const errData = err?.response?.data
      setIsLoading(false)
      setIsShowOtpScreen(false)
      let isForceLogin = false;
      let route = global?.prevRoute || "/Home"
         route = route.slice(1) 
      if( errData?.message == "You are already logged in to another device. Do you want to continue here")isForceLogin = true
      let routeObj = {
        username :userId, loginType :"otpLogin", title:"Login", type : "Error",
        msg: errData?.message, btnText :isForceLogin ? "Continue":"Back To Login",
        navigation : isForceLogin ? route : "Login", isForceLogin : isForceLogin,
        keepMeSignIn : isRememberChecked  ? "Y" :"N"
    }
    RootNavigation.navigate("ResponseScreen",{ routeObj  })
    })
  }

  const onClickGetOtp = () => {
    setErrorMessage("")
    setRequestOtp(true)
    global.loginTYpe = "otpLogin",
    setOtp("")
    global.mobileNum = userId
    let reqObj = { type: "loginByOTP", flag: "1", id: userId,};
    onSendOtp(reqObj)
  };

  const onValidateOtp = () => {
    setErrorMessage("")
    const keepMeSignIn = isRememberChecked ? "Y" : "N"; // Dynamically setting the value
    let reqObj = { type: "loginByOTP", otp: otp, requestId: otpResponse?.response?.otp + "", keepMeSignIn : keepMeSignIn};
    validateOtp(reqObj).then(async res => {
      setIsLoading(false)
      if (res?.status == 200) {
        if (res?.data?.access_token) {
          const loginData = await decrypt(res?.data?.access_token)
          AsyncStorageFunc.storeData('TOKEN', res?.data?.access_token)
          global.token = res?.data?.access_token;
          global.userId = loginData.userId;
          global.userCd = loginData.userCd;
          global.fullName = loginData.fullName ? loginData.fullName : "";
          global.userType = loginData.userType;
          setIsLoggedIn(true)
          let route = global?.prevRoute || "/Home"
              route = route.slice(1) 
          RootNavigation.navigate(route, { params: { showConfig: "showConfig"}, })
          global.activeScreen = route
          global.showConfig = true
        }
      } else if (res?.data?.statusCode < 0) {
        setIsShowOtpScreen(false)
        const routeObj = {
          title: "Login with Otp",
          type: "Error",
          msg: res?.data?.message,
          btnText: "Ok",
          navigation: "Login",
        }
        RootNavigation.navigate("ResponseScreen", { data: routeObj })
      }
    }).catch(err => {
      const errData = err?.response?.data
      setIsLoading(false)
      if(errData?.message == "Invalid OTP"){
        setErrorMessage(errData?.message)
      }else{
      setIsShowOtpScreen(false)  
      let isForceLogin = false;
      let route = global?.prevRoute || "/Home"
              route = route.slice(1) 
      if (errData?.message == "You are already logged in to another device. Do you want to continue here") isForceLogin = true
      const routeObj = {
        username: userId,
        loginType: "otpLogin",
        title: "Login",
        type: "Error",
        msg: errData?.message,
        btnText: isForceLogin ? "Continue" : "Back To Login",
        navigation: isForceLogin ? route : "Login",
        isForceLogin: isForceLogin,
        keepMeSignIn : keepMeSignIn
      }
      RootNavigation.navigate("ResponseScreen", {routeObj })
    }
    })
  };

  useEffect(() => {
    if (requestOtp) {
      const interval = setInterval(() => {
        if (second >= 0) {
          setSecond((prevSec) => {
            if (prevSec > 0) return prevSec - 1;
            else { return 0;}
          });
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [requestOtp, isShowOtpScreen]);

  useEffect(() => {
    if (timer) {
      const interval = setInterval(() => {
        if (second >= 0) {
          setSecond((prevSec) => {
            if (prevSec > 0) return prevSec - 1;
            else { return 0;}
          });
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);


  const renderLoginWithOtp = () => {
    return (
      <View style={{ width: "80%", alignSelf: "center" }}>
        <CText.enterOtpDescStyle  style={{lineHeight: 18, marginBottom: 5,  marginHorizontal: "5%", paddingTop: 20, opacity: 0.5,  }} > {otpResponse?.message} </CText.enterOtpDescStyle>
        <View style={styles.inputWrapper}>
          <View style={styles.mblPrefixText}>
            {userId?.length > 0 && <Text>{"+91"}</Text>}
          </View>
          <CustomInput
            value={userId}
            placeholder={"Mobile Number"}
            maxlength={20}
            onValueChanged={(t) => {setUserId(t); }}
            patternDif={mobileRegex}
            errorMessage={""}
            type="number"
            keyboardType="numeric"
            maxLength={10}
            style={styles.mblTextInput}
              />
          <View style={{marginLeft:-10}}>
            <CCheckbox termsText={"Remember me"} setIsTermsChecked={setIsRememberChecked} isTermsChecked={isRememberChecked} />
          </View>
          {requestOtp &&
          <View>
            <View style={styles.otpInputBoxWidget}>
              <CustomInput
                value={otp}
                onValueChanged={(e) => setOtp(e)}
                style={styles.textInputStyle}
                maxLength={6}
                pattern={/^\d{6}$/}
                placeholder={"Enter OTP"}
                errorMessage={"Enter Valid OTP"}
                type="number"
                keyboardType="numeric"
              />
              <View style={styles.resendBg}>
            <CountdownTimer requestOtp={requestOtp} isShowOtpScreen={isShowOtpScreen} onClickGetOtp={onClickGetOtp} counterRef={counterRef} screenType={screenType} />
              </View>
            </View>
            <Text style = {{color : "red"}}>{errormsg}</Text>
            </View>
          }
        </View>
        <View style={styles.btmBtnWidget}>
          { requestOtp ?
              <CustomButton text={"Sign In"} onPress={!otpPattern.test(otp) ? ()=>{} : onValidateOtp} disable={!otpPattern.test(otp) ? true : false}  />
              :(!mobileRegex.test(userId) ?
                <CustomButton text={"Request OTP"} disable={true}/> :
              <CustomButton text={"Request OTP"} onPress={() => onClickGetOtp() } disable={isSmallDevice && mobileRegex.test(userId)? true: false} />
              )  
          }
        </View>
        <Text style={styles.loginBtmText}> {isCorporate ? "Are you a retail customer? " : "Are you a corporate business? "}
          <Text onPress={() => { Linking.openURL( "https://etoll.idfcbank.com/dimtsportal/login?expired" ); }} style={styles.loginHereText} > {"Login here"} </Text>
        </Text>
      </View>
    );
  };

  const onLoginSwitch = (params) => {
    setIsShowOtpScreen(params)
    setPasswordString("")
    setOtp("")
    setRequestOtp(false)
    setOtpResponse("")
  }

  const renderLoginUi = () => {
    return (
      <View style={styles.container}>
        <View style={styles.rectangle41}>
          <CImage.LoginTitleIcon></CImage.LoginTitleIcon>
          <CText.loginText style={{ justifyContent: "center", paddingLeft: 10 }}  > {isCorporate ? "Corporate Login" : "Customer Login"} </CText.loginText>
        </View>
        <View style={{ width: '100%' }}>
          <View style={styles.tabsWrapper}>
            <View>
              <TouchableOpacity onPress={() => onLoginSwitch(true)}>
              <CText.signInText style={{color: isShowOtpScreen ? COLORS.black300 : COLORS.gray200,fontWeight: isShowOtpScreen ? 600 : 300, }} > {"Sign in with Mobile"} </CText.signInText>
              </TouchableOpacity>
            </View>
            <View style={styles.tabsLine} />
            <View>
              <TouchableOpacity onPress={() => onLoginSwitch(false)}>
              <CText.signInText style={{ color: isShowOtpScreen == false ? COLORS.black300 : COLORS.gray200, fontWeight: isShowOtpScreen == false ? 600 : 300, }}  > {"Sign in with User ID"} </CText.signInText>
              </TouchableOpacity>
            </View>
          </View>
          {isShowOtpScreen == false ? (
            <View
              style={styles.userIdWidget}>
              <View style={{ width: '80%' }}>
                {userId?.length > 0 ? <Text style={styles.labelStyle}>{'User ID '}</Text> : null}
                <CustomTextInput
                  value={userId}
                  placeholder={'User ID '}
                  maxlength={20}
                  onChangeText={(t) => { setUserId(t); }}
                  patternDif={/[^A-Za-z0-9.]/g}
                  // onFocus={() => onFocusHandler('userId')}           
                />
                <CImage.InputUserIcon></CImage.InputUserIcon>
              </View>
              <View style={{ marginTop: 20, width: '80%' }}>
                {passwordString.length > 0 ? <Text style={styles.labelStyle}>{'Password *'}</Text> : null}
                <View style={styles.styleWidget}>
                  <TextInput
                   onFocus={() => onFocusHandler('password')}
                    placeholder="Password"
                    value={passwordString}
                    ref={inputRef}
                    style={{ textAlign: 'left',  paddingLeft: 10, marginTop: 10, fontSize: 13, opacity :(passwordString.length)==0? 1: showPassword?1:0 }} // Move the input off-screen
                    onChangeText={handleInputChange}
                  />
                </View>
                {passwordString.length > 0 && (<TouchableOpacity style={styles.eyeIcon} onPress={() => setShowPassword(!showPassword)}><Text> <CImage.PasswordIcon /> </Text></TouchableOpacity>) }
                 <Text style={{ fontSize: 13, paddingLeft: 10, paddingTop: 15,minHeight:35 }}>{showPassword ? null : maskInput(passwordString)   }</Text> 
              </View>
              <View style={styles.forgotTextWidget}>
                <View style={{ marginLeft: -12, marginTop: -5 }}>
                  <CCheckbox termsText={'Remember me'} setIsTermsChecked={setIsRememberChecked} isTermsChecked={isRememberChecked} />
                </View>
                <TouchableOpacity onPress={() => RootNavigation.navigate('SelectForgotScreen')}>
                <CText.textStyleForgot> {"Forgot User Id/Password?"} </CText.textStyleForgot>
                </TouchableOpacity>
              </View>
              <View style={styles.captchaBg}>
                <View style={styles.captchaTextWidget}>
                   <CText.captchaText style={{ paddingLeft: 4 }}> {captcha} </CText.captchaText>
                  <TouchableOpacity onPress={() => {  generateCaptcha();}} style={styles.captchaIconWrapper}>
                    <CImage.ReloadCaptchaIcon></CImage.ReloadCaptchaIcon>
                  </TouchableOpacity>
                </View>
                <View
                  style={styles.captchaWidget}
                  removeClippedSubviews={true}>
                  {Platform.OS == 'web' ? (
                    <input
                      value={enteredCaptcha}
                      onChange={(t) => setEnteredCaptcha(t.target.value.replace(/[^0-9a-zA-Z]+/gi, ''))}
                      placeholder={'Enter captcha code'}
                      maxLength={7}
                      onPaste={(e) => {
                        e.preventDefault();
                        return false;
                      }}
                      style={styles.captchaTextWeb}
                    />
                  ) : (
                    <TextInput contextMenuHidden={true} onFocus={() => Clipboard.setString('')} value={enteredCaptcha} onChangeText={(t) => setEnteredCaptcha(t)} placeholder={'Enter captcha code'} style={styles.captchaInputStyle} maxLength={7} />
                  )}
                </View>
              </View>
              <View style={styles.signInWidget}>
                <CustomButton  onPress={userId && passwordString && enteredCaptcha.length > 3 ? onSubmit : null} disable={userId && passwordString && enteredCaptcha.length > 3 ? false : true} text={'Sign in'} />
              </View>
              <Text style={styles.loginBtmText}>
                {isCorporate ? 'Are you a retail customer? ' : 'Are you a corporate business? '}
                <Text onPress={() => { Linking.openURL('https://etoll.idfcbank.com/dimtsportal/login?expired'); }} style={styles.loginHereText}> {'Login here'} </Text>
              </Text>
            </View>
          ) : (
            renderLoginWithOtp()
          )}
        </View>
      </View>
    );
  }
  return (
    <View style={styles.mainContainerStyle}>
      <View style={{ flex: 1 }}>
        <Header text={"Login"} />
        <View style={styles.bodyContainerStyle}>
          <View style={styles.bodyLeftViewStyle}> 
            {renderLoginUi()}
            <View style={styles.loginTabIcons}>
              <LoginTabIcons />
            </View>
            {!isShowOtpScreen && (
              <View style={styles.virtualkeycheckbox}>
                <CCheckboxWithLabel value={useVirtualKeyboard && activeField === 'password'} onValueChange={() => toggleKeyboard('password')} label="Use Virtual Keyboard" setIsTermsChecked={setUseVirtualKeyboard} isTermsChecked={useVirtualKeyboard} />
              </View>) 
            }
          </View>
          {/* show virtual keyboard */}
          {useVirtualKeyboard && !isShowOtpScreen ? (
           <View style={styles.bodyRightViewStyle}>
                           <VirtualKeyboard 
                                activeField={activeField}
                                setInputValue={setInputValue}
                                onClose={() => setUseVirtualKeyboard(false)}
                                keyboardType="alphanumeric"
                            /> 
             </View> ) : (
              <LoginRightWidget />
            )
          }

        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.mobileContentWrapper}>
            <CImage.IDFCLogo></CImage.IDFCLogo> 
            <CImage.FFLogoSmall></CImage.FFLogoSmall> 
          </View>
          <View style={styles.mobileContentWidget} >
            {renderLoginUi()}
            {!isShowOtpScreen && (
              <View style={styles.virtualkeycheckbox}>
                <CCheckboxWithLabel value={useVirtualKeyboard && activeField === 'password'} onValueChange={() => toggleKeyboard('password')} label="Use Virtual Keyboard" setIsTermsChecked={setUseVirtualKeyboard} isTermsChecked={useVirtualKeyboard} />
              </View>) 
            }
            {useVirtualKeyboard && !isShowOtpScreen ? (
            <View style={styles.bodyRightViewStyle}>
                            <VirtualKeyboard 
                                  activeField={activeField}
                                  setInputValue={setInputValue}
                                  onClose={() => setUseVirtualKeyboard(false)}
                                  keyboardType="alphanumeric"
                              /> 
              </View> ) : (
                <LoginRightWidget />
              )
            }
          </View>     
          <LoginMoibleContent />
        </View>
        <View style={styles.footerWidget}>
          <LoginFooter />
        </View>
      </View>
    </View>
  );
};




//make this component available to the app
export default LoginComponent;
